import React, { useEffect, useState } from 'react';
import {
	Popper,
	Grow,
	Typography,
	List,
	ListItem,
	Checkbox,
	Paper,
	ClickAwayListener,
	FormControlLabel,
	Button,
	Link,
	Box,
	Tooltip,
	ListItemText,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { CancelIcon } from '../../config/svg/Action';
import { OKRButton } from '../Common/OKRButton';
import { NewFilterIcon } from '../../config/svg/CommonSvgIcon';
import { UpArrowIcon, DownArrowIcon } from '../../config/svg/ArrowSvg';
import { BorderCheckboxIcon, CheckedIcon } from '../../config/svg/formElementIcons';

export const KpiApprovalFilter: React.FC<any> = (props) => {
	const {
		setFinalFilterCondition,
		finalFilterCondition,
		defaultSearchFilter,
		appliedFilter,
		setAppliedFilter,
		categories,
		showChip = true,
	} = props;
	const { t } = useTranslation();
	const {} = props;
	const [localFilterCondition, setLocalFilterCondition] = useState<any>({ ...defaultSearchFilter });
	const [openFilter, setOpenFilter] = useState<boolean>(false);
	useEffect(() => {
		let filterData: any = {
			kpiCategoryMasterId: [...finalFilterCondition?.kpiCategoryMasterId],
		};
		setLocalFilterCondition({ ...filterData });
	}, [openFilter]);
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	const handleToggleFilter = (event: any) => {
		setAnchorEl(event.currentTarget);
		setOpenFilter((prev) => !prev);
	};

	const handleClose = (event: any) => {
		setAnchorEl(null);
		setOpenFilter(false);
	};

	const handleFilterChanged = (value: any, key: string) => {
		let filterData: any = { ...localFilterCondition };
		let indexParent = filterData[key].findIndex((item: any) => item.id === value.id);
		if (indexParent === -1) {
			filterData[key].push({ ...value });
		} else {
			filterData[key].splice(indexParent, 1);
		}
		setLocalFilterCondition(filterData);
	};
	const handleApplyFilterClick = (filtersData: any) => {
		setAppliedFilter(true);
		let filterData: any = {
			kpiCategoryMasterId: [...filtersData.kpiCategoryMasterId],
		};
		setFinalFilterCondition({ ...filterData });
	};

	const clearFilter = () => {
		setAppliedFilter(true);
		setFinalFilterCondition({ ...defaultSearchFilter });
	};

	const handleCloseChip = (value: any, key: string) => {
		let filterData: any = { ...finalFilterCondition };
		let indexParent = filterData[key].findIndex((item: any) => item.id === value.id);
		if (indexParent !== -1) {
			filterData[key].splice(indexParent, 1);
		}
		setAppliedFilter(true);
		setFinalFilterCondition({ ...filterData });
	};
	const getFilterCount = () => {
		let count = 0;
		if (finalFilterCondition.kpiCategoryMasterId.length > 0) {
			count += finalFilterCondition.kpiCategoryMasterId.length;
		}
		return count;
	};
	return (
		<Box className='filter-list-dropdown kpi-filter-list-dropdown'>
			{showChip && (
				<Box className={`filter-chip `}>
					<List>
						{getFilterCount() > 0 ? (
							<>
								{finalFilterCondition.kpiCategoryMasterId.length > 0 &&
									finalFilterCondition.kpiCategoryMasterId.slice(0, 1).map((item: any, index: any) => (
										<ListItem key={index}>
											<Tooltip arrow title={item.name}>
												<Typography variant='body2'>{item.name}</Typography>
											</Tooltip>
											<Button className='cancel-btn' onClick={() => handleCloseChip(item, 'kpiCategoryMasterId')}>
												<CancelIcon />
											</Button>
										</ListItem>
									))}
								{getFilterCount() > 1 && (
									<ListItem className='more-filter-count'>
										<Typography variant='body2'>+{getFilterCount() - 1}</Typography>
									</ListItem>
								)}

								<ListItem className='clear-all'>
									<Link onClick={clearFilter}>{t('clearAll')}</Link>
								</ListItem>
							</>
						) : (
							<></>
						)}
					</List>
				</Box>
			)}
			<OKRButton
				className={`list-filter-btn ${openFilter ? 'active' : ''}`}
				icon={<NewFilterIcon />}
				text={
					<span className='filter-txt'>
						{t('filterLabel')}
						{openFilter ? <UpArrowIcon /> : <DownArrowIcon />}
					</span>
				}
				handleClick={handleToggleFilter}
				id='dashboard-filter-btn'
			/>
			<Popper
				className={`okr-filter alignmentmap-filter-list kpi-filter-list`}
				open={openFilter}
				anchorEl={anchorEl}
				id='workflow-reversal-filter'
				placement={'bottom-end'}
				modifiers={{
					flip: {
						enabled: false,
					},
				}}
			>
				{({ TransitionProps }) => (
					<Grow {...TransitionProps}>
						<ClickAwayListener onClickAway={handleClose}>
							<Paper>
								<Box className='alignmentFilterWrap'>
									<Box className='okr-type-filter'>
										<Typography variant='body2'>{t('byCategory')}:</Typography>
										<List disablePadding>
											{categories &&
												categories.length &&
												categories.map((item: any, index: any) => {
													return (
														<>
															<ListItem>
																<FormControlLabel
																	control={
																		<Checkbox
																			icon={<BorderCheckboxIcon />}
																			checkedIcon={<CheckedIcon />}
																			checked={
																				localFilterCondition?.kpiCategoryMasterId &&
																				localFilterCondition.kpiCategoryMasterId.findIndex(
																					(val: any) => item.kpiCategoryMasterId === val.id
																				) !== -1
																			}
																			value={item.kpiCategoryMasterId}
																			onChange={(e) =>
																				handleFilterChanged(
																					{ ...item, id: item.kpiCategoryMasterId },
																					'kpiCategoryMasterId'
																				)
																			}
																			color='primary'
																		/>
																	}
																	label={item?.name}
																/>
															</ListItem>
														</>
													);
												})}
										</List>
									</Box>
								</Box>
								<Box className='filter-list-actions'>
									<OKRButton
										className='apply-btn btn-primary'
										text={t('applyLabel')}
										handleClick={(e: any) => {
											handleClose(e);
											handleApplyFilterClick(localFilterCondition);
										}}
									/>
								</Box>
							</Paper>
						</ClickAwayListener>
					</Grow>
				)}
			</Popper>
		</Box>
	);
};
